import { useGetOrderDetailById } from 'shared/hooks';
import { useSubstitutionFlowStatusAlertLang } from './useSubstitutionFlowStatusAlertLang';

import type { OrderId } from 'shared/domain';

export function useSubstitutionFlowStatusAlert(props: Props) {
  const { orderId } = props;

  const {
    data: { substitutionFlowState },
  } = useGetOrderDetailById(orderId);
  const status = substitutionFlowState?.status;
  const isRendered =
    status !== 'accepted' && status !== 'refused' && status !== undefined;

  const lang = useSubstitutionFlowStatusAlertLang({ status });

  return {
    lang,
    isRendered,
  };
}

interface Props {
  orderId: OrderId;
}
